import { render } from "./logoutBtn.vue?vue&type=template&id=27040211"
import script from "./logoutBtn.vue?vue&type=script&lang=js"
export * from "./logoutBtn.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Riman\\Web\\Alex\\ars\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__